import Dropdown from 'rc-dropdown';
import 'rc-dropdown/assets/index.css';
import usePart from '@/lib/use-part';
import { history, styled, SummaryArticle, useBook, useFile, useIntl } from 'topwrite';
import { VscChevronDown } from '@react-icons/all-files/vsc/VscChevronDown';
import { VscChevronUp } from '@react-icons/all-files/vsc/VscChevronUp';
import { useState } from 'react';

export default function Versions() {
    const intl = useIntl();
    const currentPart = usePart();
    const { summary } = useBook();
    const [visible, setVisible] = useState(false);
    const file = useFile();

    if (summary.getParts().length <= 1) {
        return null;
    }

    return <Dropdown
        visible={visible}
        onVisibleChange={setVisible}
        trigger={['click']}
        overlay={<Menu>
            {summary.getParts().map((part, index) => {
                return <MenuItem
                    key={index}
                    onClick={() => {
                        const first = SummaryArticle.findArticle(part, article => !!article.getPath());
                        if (first) {
                            history.push(file.relative(first.getPath()));
                            setVisible(false);
                        }
                    }}
                >
                    {part.title || intl.formatMessage({ defaultMessage: '未命名分组' })}
                </MenuItem>;
            })}
        </Menu>}
        align={{
            offset: [-3, -10]
        }}
    >
        <Button>
            <span>{currentPart.title || intl.formatMessage({ defaultMessage: '未命名分组' })}</span>
            {visible ? <VscChevronUp /> : <VscChevronDown />}
        </Button>
    </Dropdown>;
}

const MenuItem = styled.div`
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 15px;

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  &:hover {
    background-color: #f2f2f2;
  }
`;

const Menu = styled.div`
  background: #fff;
  padding: 8px 4px;
  max-height: 150px;
  max-width: 200px;
  min-width: 150px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #eaeaea;
  overflow-y: auto;
  border-radius: 5px;
`;

const Button = styled.div`
  display: flex;
  margin-left: 12px;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 15px;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  svg {
    flex-shrink: 0;
  }

  @media (max-width: 996px) {
    max-width: 100px;
    overflow: hidden;
    margin-left: auto;
  }
`;
